module.exports = __webpack_public_path__ + "img/amex.0dd939b6.png";